import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { MainService } from "../../main.service";
import { MatSnackBar } from "@angular/material";
import { ImageCroppedEvent } from "ngx-image-cropper";
import Swal from "sweetalert2";
@Component({
  selector: "app-choir-detail",
  templateUrl: "./choir-detail.component.html",
  styleUrls: ["./choir-detail.component.scss"],
})
export class ChoirDetailComponent implements OnInit {
  constructor(
    private modalService: NgbModal,
    private mainservice: MainService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private router: Router
  ) {}
  closeResult: string;
  croppedImage: any = "";
  carPic: any = "";
  imageChangedEvent: any = "";
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  cities: any = [];
  ShowFilter = false;
  limitSelection = false;
  id: any;
  userData: any;
  firstName: any;
  CouponCode: any = "";
  lastName: any;
  age: any;
  gender: any = "";
  addtChild: boolean = false;
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.id = params["id"];
      this.getChoirList();
    });
    this.userData = JSON.parse(localStorage.getItem("userData"));
    // this.getKidList();
    this.getlatestKidList();
    this.getCouponList();
    // this.cities = [
    //   { item_id: 1, item_text: "New Delhi" },
    //   { item_id: 2, item_text: "Mumbai" },
    //   { item_id: 3, item_text: "Bangalore" },
    //   { item_id: 4, item_text: "Pune" },
    //   { item_id: 5, item_text: "Chennai" },
    //   { item_id: 6, item_text: "Navsari" },
    // ];
  }
  ChoirList: any;
  addChild() {
    this.addtChild = true;
  }

  saveChild() {
    let req = {
      firstName: this.firstName,
      lastName: this.lastName,
      age: this.age,
      gender: this.gender,
      profilePic: this.profileImag,
    };
    this.mainservice.addChild(req).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.addtChild = false;

          // this.getKidList();
          this.getlatestKidList();
          this.firstName = "";
          this.lastName = "";
          this.age = "";
          this.gender = "";
          this._snackBar.open("Kid Added Successfully!!", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  //   "choirId":"66be4ffa301a50e7fa9d3e4f",
  //   "numberOfKids":2,
  //   "kidsArray":[
  //       "66be1b4136da0f293d0c98e1",
  //       "66be1b4136da0f293d0c98e2"
  //   ]
  // }
  bookingDetail: any;
  saveBookingChild(data: any, Btn: any, str: any) {
    let req: any = {};

    req["numberOfKids"] = this.selectedFullItems.length;
    req["choirId"] = this.ChoirList.choirId;
    req["kidsArray"] = this.selectedFullItems;
    // req["kidsArray"] = this.selectedItems.map((item) => item._id);
    // let req = {
    //   firstName: this.firstName,
    //   lastName: this.lastName,
    //   age: this.age,
    //   gender: this.gender,
    // };
    this.modalRef.close();
    this.mainservice.addBooking(req).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          // this.addtChild = false;
          this.bookingDetail = res["data"]["response"];
          this.getBookingDetail();
          this.OpenModal(data, Btn, str);
          this._snackBar.open("Booking Added Successfully!!", "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        }
      },
      (err) => {
        //     this.isLoading = false;
     this.modalRef.close();
      }
    );
  }

  bookingDetail2: any;
  kidsDetail: any;
  getBookingDetail() {
    // this.isLoading = true;
    // debugger;
    let query = "bookingDetailId=" + this.bookingDetail?.bookingDetailId;
    this.mainservice.getBookingApi(query).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.bookingDetail2 = res["data"];

          this.kidsDetail = this.bookingDetail2?.kidsArray;
          console.log(this.bookingDetail, "this.bookingDetail2 ");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }

  isAppliedCode: boolean = false;
  applyCode() {
    // this.isLoading = true;
    // let query = "choirId=" + this.id;
    if (this.CouponCode == "") {
      this._snackBar.open("Please Select Discount Code!!", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
      return;
    }

    let req = {
      couponId: this.CouponCode,
      bookingDetailId: this.bookingDetail?.bookingDetailId,
    };
    this.mainservice.couponApply(req).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.isAppliedCode = true;
          this.getBookingDetail();
          console.log(this.bookingDetail, "response");
        }
      },
      (err) => {
        this.CouponCode = "";
        //     this.isLoading = false;
      }
    );
  }
  removeCode() {
    let req = {
      couponId: this.CouponCode,
      bookingDetailId: this.bookingDetail?.bookingDetailId,
    };
    this.mainservice.removeCoupon(req).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.isAppliedCode = false;
          this.CouponCode = "";

          this.getBookingDetail();
          console.log(this.bookingDetail, "response");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  stripeData: any;
  saveBooking() {
    if (this.userData?.isAutoPaymentEnabled) {
      const bookingDetailId = this.bookingDetail?.bookingDetailId;
      this.router.navigate(["/main/payment-cards"], {
        queryParams: { bookingId: bookingDetailId },
      });
      this.modalService.dismissAll();
    } else {
      let bookingDetailId = this.bookingDetail?.bookingDetailId;

      if (bookingDetailId) {
        let query = `bookingDetailId=${bookingDetailId}`;

        this.mainservice.createStripe(query).subscribe({
          next: (res) => {
            this.isLoading = false;
            if (res["message"] === "Success" || res["statusCode"] === 200) {
              window.open(res.data.sessionUrl, "_self");
              console.log(res, "response of stripe checkout");
            }
          },
          error: (err) => {
            this.isLoading = false;
            console.error(err, "Stripe API error");

            if (
              err?.error?.message === "Failure" &&
              err?.error?.data?.message === "Please add a card first."
            ) {
              const bookingDetailId = this.bookingDetail?.bookingDetailId;
              this.router.navigate(["/main/payment-cards"], {
                queryParams: { bookingId: bookingDetailId },
              });
              this.modalService.dismissAll();
            }
          },
        });
      } else {
        console.error("Required parameters not found in content.");
      }
    }

    // const bookingDetailId = this.bookingDetail?.bookingDetailId;
    // this.router.navigate(["/main/payment-cards"], {
    //   queryParams: { bookingId: bookingDetailId },
    // });
    // this.modalService.dismissAll();

    // let req = {
    //   bookingDetailId: this.bookingDetail?.bookingDetailId,
    // choirId: this.bookingDetail?.choirId,
    // bookingDateInSeconds: this.bookingDetail?.bookingDateInSeconds,
    // bookingTimeInSeconds: this.bookingDetail?.bookingTimeInSeconds,
    // numberOfKids: this.bookingDetail?.numberOfKids,
    // kidsArray: this.bookingDetail?.kidsArray,
    // };
    // this.mainservice.stripeBooking(req).subscribe(
    //   (res) => {
    //     //   this.isLoading = false;
    //     if (res["message"] == "Success" || res["statusCode"] == 200) {
    //       console.log(req, "req");
    //       this.stripeData = res["data"]["sessionUrl"];

    //       window.open(this.stripeData, "_self");
    //       // this.getKidList();
    //       // this._snackBar.open("Kid Added Successfully!!", "", {
    //       //   duration: 3000,
    //       //   horizontalPosition: "right",
    //       //   verticalPosition: "top",
    //       //   panelClass: ["success"],
    //       // });
    //     }
    //   },
    //   (err) => {
    //     //     this.isLoading = false;
    //   }
    // );
  }
  teachersArray: any = [];
  getChoirList() {
    // this.isLoading = true;
    let query = "choirId=" + this.id;
    this.mainservice.getChoirById(query).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.ChoirList = res.data?.choir;
          this.teachersArray = this.ChoirList.teachersArray;
          console.log(this.ChoirList, "res");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  kidList = [];
  getKidList() {
    // this.isLoading = true;
    // "userId=" + this.userData.userId +
    let query = "choirId=" + this.id;
    this.mainservice.getKidApi(query).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.kidList = res.data.kidsArray;
          // this.kidList = [
          //   {
          //     firstName: "testUser",
          //     lastName: "child1",
          //     age: 20,
          //     gender: "female",
          //     _id: "66be2ad0d7fdf6b0ce2eacb4",
          //   },
          //   {
          //     firstName: "child 2",
          //     lastName: "2",
          //     age: 19,
          //     gender: "female",
          //     _id: "66be2ad0d7fdf6b0ce2eacb5",
          //   },
          //   {
          //     firstName: "hbhjd",
          //     lastName: "sjgdf",
          //     age: 17,
          //     gender: "other",
          //     _id: "66c71c397f1b7868fd3bc37e",
          //   },
          // ];
          this.kidList = this.kidList.map((user) => ({
            ...user,
            fullName: user.firstName + " " + user.lastName,
          }));
          this.selectedItems = [];
          this.dropdownSettings = {
            singleSelection: false,
            idField: "_id",
            textField: "firstName",
            //  selectAllText: "Select All",
            //  unSelectAllText: "UnSelect All",
            itemsShowLimit: 10,
            allowSearchFilter: true,
            enableCheckAll: false,
            // disabledField: "isBookingExist", // Bind the function here
          };
          console.log(this.kidList, "res");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  bookingsArray: any = [];
  getlatestKidList() {
    // this.isLoading = true;
    // "userId=" + this.userData.userId +
    let query = "choirId=" + this.id;
    this.mainservice.getKidCalcApi(query).subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.bookingsArray = res.data.bookingsArray;
          this.kidList = res.data.kidsArray;
          const bookingNewArray = this.bookingsArray.filter(
            (booking) => booking.choirId === this.id
          );

          this.kidList.forEach((kid) => {
            // Check if this kid is present in any of the bookings' kidsArray
            const isKidBooked = bookingNewArray.some((booking) =>
              booking.kidsArray.some((bookedKid) => bookedKid.id === kid.id)
            );

            // If the kid is found in the booking, set the flag to true
            if (isKidBooked) {
              kid.isBookingExist = true;
            } else {
              kid.isBookingExist = false;
            }
          });
          console.log(this.kidList, " last kidslist");
          this.selectedItems = [];
          this.kidList = this.kidList.map((user) => ({
            ...user,
            fullName: user.firstName + " " + user.lastName,
          }));
          this.dropdownSettings = {
            singleSelection: false,
            idField: "_id",
            textField: "firstName",
            //  selectAllText: "Select All",
            //  unSelectAllText: "UnSelect All",
            itemsShowLimit: 10,
            allowSearchFilter: true,
            enableCheckAll: false,
            // disabledField: "isBookingExist", // Bind the function here
          };
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  couponList: any = [];
  getCouponList() {
    // this.isLoading = true;

    this.mainservice.getCouponApi().subscribe(
      (res) => {
        //   this.isLoading = false;
        if (res["message"] == "Success") {
          this.couponList = res.data.couponList;

          this.selectedItems = [];
          this.kidList = this.kidList.map((user) => ({
            ...user,
            fullName: user.firstName + " " + user.lastName,
          }));
          this.dropdownSettings = {
            singleSelection: false,
            idField: "_id",
            textField: "fullName",
            //  selectAllText: "Select All",
            //  unSelectAllText: "UnSelect All",
            itemsShowLimit: 10,
            allowSearchFilter: true,
            enableCheckAll: false,
            // disabledField: "isBookingExist", // Bind the function here
          };
          console.log(this.kidList, "res");
        }
      },
      (err) => {
        //     this.isLoading = false;
      }
    );
  }
  isItemDisabled(item: any): boolean {
    return item.isBookingExist === true;
  }
  selectedFullItems: any = [];
  onItemSelect(item: any) {
    const selectedKid = this.kidList.find((kid) => kid._id === item._id);

    if (selectedKid) {
      const index = this.selectedFullItems.findIndex(
        (kid) => kid._id === item._id
      );

      if (index > -1) {
        this.selectedFullItems[index] = selectedKid;
      } else {
        this.selectedFullItems.push(selectedKid);
      }

      console.log(
        "Updated selectedFullItems with full objects only:",
        this.selectedFullItems
      );
    } else {
      console.error("Selected item not found in kidList");
    }
  }

  onDeSelect(item: any) {
    // Remove the full object from selectedFullItems when it is deselected
    this.selectedFullItems = this.selectedFullItems.filter(
      (kid) => kid._id !== item._id
    );
    console.log(
      "Updated selectedFullItems after deselect:",
      this.selectedFullItems
    );
  }
  onSelectAll(items: any) {
    console.log("onSelectAll", items);
  }
  toggleSave() {
    var icon = document.getElementById("toggleIcon") as HTMLImageElement;
    if (icon.src.includes("unsave.svg")) {
      icon.src = "../../../../assets/images/Saved.svg";
    } else {
      icon.src = "../../../../assets/images/unsave.svg";
    }
  }
  isLoading: boolean = false;
  savechoir(data, text) {
    this.isLoading = true;
    let req = {
      choirId: data._id,
    };
    this.mainservice.saveChoir(req).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success" || res["message"] == "success") {
          this.getChoirList();
          this._snackBar.open(res.data.message, "", {
            duration: 3000,
            horizontalPosition: "right",
            verticalPosition: "top",
            panelClass: ["success"],
          });
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, {
      allowSearchFilter: this.ShowFilter,
    });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, {
        limitSelection: 2,
      });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, {
        limitSelection: null,
      });
    }
  }
  scholardetail: any;
  private modalRef: NgbModalRef;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  OpenModal(content, btn, data) {
    // this.scholardetail = data;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "md",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    this.selectedItems = [];
    this.selectedFullItems = [];
    this.CouponCode = "";
    this.isAppliedCode = false;
    //  this.questList = [];
  }
  convertSecondsToDate(seconds: number): string {
    const date = new Date(seconds * 1000);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  }

  convertSecondsToTime(seconds: number): string {
    const date = new Date(seconds * 1000);

    let hours = date.getUTCHours(); // Use getUTCHours to avoid timezone offsets
    const minutes = date.getUTCMinutes();

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle the case where hours = 0, should be 12 AM

    // Pad minutes with leading zero if necessary
    const minutesStr = minutes < 10 ? "0" + minutes : minutes;

    return `${hours}:${minutesStr} ${ampm}`;
  }

  mouseOver() {}
  imageChangedEvent2: any;
  fileChangeEvent2(event: any, content: any, btn: any, i: any): void {
    this.isLoading = true;
    let file, img;

    if (
      (file = event.target.files[0]) &&
      (file.type === "image/png" || file.type === "image/jpeg")
    ) {
      img = new Image();
      this.imageChangedEvent2 = event;
      this.OpenModalKid(content, btn, i);
    } else {
      if (file) {
        Swal.fire({
          icon: "error",
          html: "Unsupported File Type. Only jpeg and png is allowed!",
        });
      } else {
        return;
      }
    }
    this.isLoading = false;
  }

  index: any;
  OpenModalKid(content, btn, i) {
    this.index = i;
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // console.log(this.croppedImage,'CropImage')
  }

  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  isUploading: boolean = false;
  cancel(): void {
    this.croppedImage = null;
    this.imageChangedEvent = null;
    this.isUploading = false;
    setTimeout(() => {
      /** spinner ends after 1 seconds */
      this.isUploading = true;
    }, 1000);
  }
  b64toBlob(dataURI) {
    var byteString = atob(dataURI.split(",")[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: "image/jpeg" });
  }
  kidImage: any;
  profileImag: any;
  save2() {
    this.closeModal();
    const blob = this.b64toBlob(this.croppedImage);
    this.isLoading = true;
    this.imageChangedEvent = null;
    this.mainservice.uploadImages(blob).subscribe((res) => {
      this.isLoading = false;

      if (res["message"] === "Success") {
        this.isLoading = false;
        this.kidImage = res.data.url;
        // if (this.addKid == true) {
        this.profileImag = this.kidImage;
        // }
        // this.childArray[this.currentChildIndex].profilePic = this.kidImage;

        // this.userForm.value.profilePic = this.storeImage;

        // console.log(this.userForm.value.profilePic, "profile pic");
      }
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
